{
  "colorFormat": "Format boje",
  "hex": "Hex",
  "hsb": "HSB",
  "hsl": "HSL",
  "rgb": "RGB"
}
